import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=5f49cac4&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=js&"
export * from "./Tasks.vue?vue&type=script&lang=js&"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=5f49cac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49cac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f49cac4')) {
      api.createRecord('5f49cac4', component.options)
    } else {
      api.reload('5f49cac4', component.options)
    }
    module.hot.accept("./Tasks.vue?vue&type=template&id=5f49cac4&scoped=true&", function () {
      api.rerender('5f49cac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tasks.vue"
export default component.exports